// copied from zion-session
import Cookies from 'js-cookie'
import { isLoggedIn } from '@fs/zion-config'

export function getSessionId() {
  return Cookies.get('fssessionid')
}

export const sessionTypes = {
  unknown: 'UNKNOWN',
  noSession: 'NO_SESSION',
  anonymousSession: 'ANONYMOUS_SESSION',
  userSession: 'USER_SESSION',
}
export function getSessionType() {
  const windowDefined = typeof window !== 'undefined'
  if (!windowDefined || typeof isLoggedIn === 'undefined') return sessionTypes.unknown
  if (!getSessionId()) return sessionTypes.noSession
  if (isLoggedIn) return sessionTypes.userSession
  return sessionTypes.anonymousSession
}
export class NoUserSessionError extends Error {
  constructor(message) {
    super(message)
    this.name = 'NoUserSessionError'
  }
}
export function validUserSessionOrError() {
  const sessionType = getSessionType()
  if (
    sessionType === sessionTypes.noSession ||
    sessionType === sessionTypes.anonymousSession ||
    (sessionType === sessionTypes.unknown && !getSessionId())
  ) {
    throw new NoUserSessionError('No User Session Id')
  }
}
